import type { SilentRequest } from "@azure/msal-browser";
import type { IMsalContext } from "@azure/msal-react";
import { createContext, useContext } from "react";

export type ProviderApiConfig = {
  apiBaseUri: string;
  apiSubscriptionKey: string;
  apiEndpointPrefix: string;
};

export type ApiCoreConfig = {
  providers: Record<string, ProviderApiConfig>;
  makeTokenRequestObject: (
    msalInstance: IMsalContext["instance"],
  ) => SilentRequest;
};

const ApiCoreConfigContext = createContext<ApiCoreConfig | null>(null);

type Props = {
  config: ApiCoreConfig;
  children: React.ReactNode;
};

export function ApiCoreConfigProvider({ config, children }: Props) {
  return (
    <ApiCoreConfigContext.Provider value={config}>
      {children}
    </ApiCoreConfigContext.Provider>
  );
}

export function useApiCoreConfig(): ApiCoreConfig {
  const config = useContext(ApiCoreConfigContext);
  if (!config) {
    throw new Error(
      "useApiCoreConfig must be used within an ApiCoreConfigProvider",
    );
  }
  return config;
}
